module.exports = Object.assign({}, require('./bn'), require('./constants'))
